/**
 * 禁用开发者工具快捷键、复制相关按键和鼠标右键
 * 防止用户通过 F12、Ctrl、Shift 等快捷键打开浏览器检查窗口或复制内容
 */
export function useDisableDevTools() {
    const handler = (e) => {
        // 禁用 F12
        if (e.key === 'F12' || e.keyCode === 123) {
            e.preventDefault()
            e.stopPropagation()
            return false
        }
        // 禁用 Ctrl 键（防止 Ctrl+Shift+I/J、Ctrl+U、Ctrl+C 等）
        if (e.ctrlKey) {
            e.preventDefault()
            e.stopPropagation()
            return false
        }
        // 禁用 Shift 键（防止 Shift+F10 等）
        if (e.shiftKey) {
            e.preventDefault()
            e.stopPropagation()
            return false
        }
    }

    // 禁用鼠标右键
    const contextMenuHandler = (e) => {
        e.preventDefault()
        e.stopPropagation()
        return false
    }

    document.addEventListener('keydown', handler)
    document.addEventListener('contextmenu', contextMenuHandler)

    // 返回清理函数
    return () => {
        document.removeEventListener('keydown', handler)
        document.removeEventListener('contextmenu', contextMenuHandler)
    }
}
